












import { Component, Vue, Prop } from 'vue-property-decorator'
import { SettingsConfirmation } from '@/views/WorkspaceSettings.vue'

interface messageColor {
  color: 'red'|'black'|'green'
}

@Component({
  name: 'confirmationMessage',
  components: { }
})
export default class ConfirmationMessage extends Vue {
  @Prop({ required: true }) confirmation!: SettingsConfirmation

  get colorMsg (): messageColor {
    if (this.confirmation.status === 'error') return { color: 'red' }
    if (this.confirmation.status === 'failure') return { color: 'red' }
    if (this.confirmation.status === 'duplicate') return { color: 'black' }
    else return { color: 'green' }
  }
  // ported but unsure if this is used anywhere
  // updateValue (value) {
  //   this.$emit('input', value)
  // }
}
